/**
 * Sanitize a string to prevent script injection in the payload.
 * Strips HTML tags and limits length.
 */
export function sanitizeString(input: string, maxLength = 10000): string {
  if (!input) return '';
  // Strip HTML tags
  let clean = input.replace(/<[^>]*>/g, '');
  // Truncate
  if (clean.length > maxLength) {
    clean = clean.slice(0, maxLength) + '...[truncated]';
  }
  return clean;
}

/**
 * Truncate inner text of an element to a reasonable length.
 */
export function truncateText(text: string, maxLength = 500): string {
  if (!text) return '';
  const trimmed = text.trim().replace(/\s+/g, ' ');
  if (trimmed.length <= maxLength) return trimmed;
  return trimmed.slice(0, maxLength) + '...';
}
